import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SessionService } from "@recore-solutions/nstar-lib";
import { ConfigurationService } from "src/app/configuration.service";
import { PermissionListGuard } from "src/app/permission-list.guard";
import { PreferencesService } from "src/app/preferences/preferences.service";
import { ListingResultComponent } from "../listing-result/listing-result.component";

@Component({
	selector: "app-listing-card",
	templateUrl: "./listing-card.component.html",
	styleUrls: ["./listing-card.component.scss"],
})
export class ListingCardComponent extends ListingResultComponent implements OnInit {
	constructor(
		protected router: Router,
		protected configurationService: ConfigurationService,
		protected preferenceService: PreferencesService,
		protected sessionService: SessionService,
		protected permissionListGuard: PermissionListGuard
	) {
		super(router, configurationService, preferenceService, sessionService, permissionListGuard);
	}

	ngOnInit() {
		super.ngOnInit();
	}
}
